module.exports = __webpack_public_path__ + "img/ico-logout--black.21822186.svg";